(function () {
    'use strict';

    angular
        .module('app')
        .controller('NavigationController', NavigationController);

    function NavigationController($scope, $rootScope, $cookies, $state, $timeout, $localStorage, AuthenticationService, UserService, RoleService, toaster, plmThemes, QuickSearchService, SharedData) {
        var model = this;
        model.logOut = logOut;
        model.LinePlanRead = false;
        model.currentUser = $localStorage.currentUser;
        model.SlidebarSettings = {
            isShowSlidebar: true
        };
        model.user = {};
        model.userId = model.currentUser.userId;
        model.user.IsActive = "true";
        model.brandAssignment = [];
        model.userRole = null;
        model.roles = [];
        model.rolePermissions = [];
        model.defaultBrandId = null;
        model.defaultSeasonId = null;
        model.defaultDivisionKey = null;
        model.useDefaultsInQuickSearch = false;
        model.searchText = "";
        $scope.userPermissions = $rootScope.userPermissions;
        $scope.state = $state;
        $scope.currentUser = model.currentUser;
        $scope.globals = $rootScope.globals;
        //$scope.isActiveState = $rootScope.isActiveState
       /* $scope.globals = $rootscope.globals*/
       

        $scope.searchClear = function (a) {
            switch (a) {
                case 1:
                    $localStorage.ss = null;
                    if ($state.current.name == 'Search') {
                        $state.reload();
                    }
                    break;
                case 2:
                    $cookies.remove('_cpss');
                    if ($state.current.name == 'criticalPath') {
                        $state.reload();
                    }
                    break;
            }
        };

        var canceller;
        $scope.getAutocomplete = function (val) {
            model.searchText = val;
            const maxResults = 5;

            if (canceller) {
                canceller.cancel("cancelled");
                canceller = null;
            }

            var quickSearch = {
                searchText: val
            };

            if (model.useDefaultsInQuickSearch === true) {
                quickSearch.brandId = model.defaultBrandId;
                quickSearch.seasonId = model.defaultSeasonId;
                quickSearch.divisionKey = model.defaultDivisionKey;
            }

            var promise = QuickSearchService.getQuickSearch(quickSearch);
            canceller = promise.canceller;

            return promise.then(function (response) {
                var protoResults = [];
                var patResults = [];
                if (response) {
                    if (response.Prototypes && response.Prototypes.length > 0) {
                        protoResults = response.Prototypes.map(function (item, index) {
                            item.group = "Colorways";
                            item.firstInGroup = index === 0;
                            item.FactNameKy = item.FactNameKy.replace(/^0+/, "");
                            return item;
                        });

                        protoResults.push({ group: "Search", searchModule: 4, searchModuleName: "Colorway" });
                    }
                    if (response.Patterns && response.Patterns.length > 0 && response.Prototypes.length <= 5) {
                        patResults = response.Patterns.map(function (item, index) {
                            item.group = "Patterns";
                            item.firstInGroup = index === 0;
                            return item;
                        });

                        patResults.push({ group: "Search", searchModule: 3, searchModuleName: "Pattern" });
                    }
                }
                return protoResults.concat(patResults);
            });
        };

        $scope.goBack = function (a) {
            
            var s = $state.includes("Search") || $state.includes("criticalPath");
            var refine = sessionStorage.getItem('refineFun');
            sessionStorage.removeItem('refineFun');
            if (($rootScope.refine && s) || (s && refine)) {
                if ((s && refine)) { } else {
                    $rootScope.refine();
                }
            } else {
                if (!a)
                    window.history.back();
            }
        };

        $scope.goToSearch = function (item) {
            if (item.PrototypeSeasonalId)
                $state.go('colorway', { prototypeSeasonalId: item.PrototypeSeasonalId });
            else if (item.PatternSeasonalId)
                $state.go('pattern', { patternSeasonalId: item.PatternSeasonalId });
            else
                $state.go('Search', { searchModule: item.searchModule, quickSearchText: model.searchText });
        };

        var themeId = model.currentUser.theme;

        var theme = isNaN(themeId) || themeId !== null ? parseInt(themeId) : 0;

        model.myThemeStyle = theme;

        function getUsersBrands() {
            UserService.getUserBrandAssignment(model.userId).then(function (response) {
                if (response) {
                    //model.isErrorBrands = false;
                    model.brandAssignment = response;
                }
                else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No brands found',
                        timeout: 5000
                    });
                }
            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while retrieving user-brand data. Please contact system administrator',
                        timeout: 5000
                    });
                });
        };

        function getRoles() {
            RoleService.getAllRoles().then(function (response) {
                if (response) {
                    //model.isErrorRole = false;
                    model.roles = response;
                }
                else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No roles found',
                        timeout: 5000
                    });
                }

            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while retrieving role data. Please contact system administrator',
                        timeout: 5000
                    });
                });
        };

        function getRolePermissions() {
            RoleService.getRolePermissions(model.userRole.RoleId).then(function (response) {
                if (response) {
                    //model.isErrorRole = false;
                    model.rolePermissions = response;
                }
                else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No permissions found for selected role',
                        timeout: 5000
                    });
                }

            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while retrieving permissions data. Please contact system administrator',
                        timeout: 5000
                    });
                });
        };


        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        };

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        };

        $scope.clearLogout = function (data) {
            AuthenticationService.clearCredentials();
        };

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        };

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        };
        
        $scope.ActiveState = function (statename) {
            console.log("statement", $state.current)

           
            return $state.current.name == statename ? true : false;
        };


        $scope.rootUpdate = function (userId, myThemeStyle) {
           
            $rootScope.accent = plmThemes.getThemes()[myThemeStyle].accent;
            $rootScope.accent2 = plmThemes.getThemes()[myThemeStyle].accent2;
            $rootScope.bg = plmThemes.getThemes()[myThemeStyle].bg;
            $rootScope.mainDark = plmThemes.getThemes()[myThemeStyle].mainDark;
            $rootScope.mainLight = plmThemes.getThemes()[myThemeStyle].mainLight;
          
        };

        $scope.rootMounted = function (x) {
            $rootScope.accent = plmThemes.getThemes()[x].accent;
            $rootScope.accent2 = plmThemes.getThemes()[x].accent2;
            $rootScope.bg = plmThemes.getThemes()[x].bg;
            $rootScope.mainDark = plmThemes.getThemes()[x].mainDark;
            $rootScope.mainLight = plmThemes.getThemes()[x].mainLight;
           
        }





        function getUsersRole() {
            UserService.getUserRole(model.userId).then(function (response) {
                if (response) {
                    model.userRole = response;
                    //getRolePermissions();
                }
                else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No role assigned to this user',
                        timeout: 5000
                    });
                }

            },
                function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while retrieving role data. Please contact system administrator',
                        timeout: 5000
                    });
                });
        };

        function getGeneralUserInfo() {
            UserService.getUser(model.userId).then(function (response) {
                if (response) {
                    model.user = response;
                }
                else {
                    model.user = null;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'No Users Found',
                        timeout: 5000
                    });
                }

            },
                function (error, status) {
                    //console.log('error');
                    model.user = null;
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'There was an error while retrieving user data. Please contact system administrator',
                        timeout: 5000
                    });
                });
        }
         
        function doSaveTheme(userId, themeId) {
            UserService.saveUserTheme(userId, themeId)
                .then(function (response) {

                    //save theme in global cookie so the change is shown right away
                    $rootScope.globals.currentUser.theme = themeId.toString();

                    $localStorage.currentUser = $rootScope.globals.currentUser;
                    console.log("locald", $localStorage.currentUser);
                }, function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: 'Error updating theme. Please contact an administrator',
                        timeout: 2500
                    });
                });
        }

        model.searchContext = { isShowSearchContext: false, text: "" };

        model.onSearch = function () {
            model.searchContext.isShowSearchContext = !model.searchContext.isShowSearchContext;
            $timeout(function () {
                $("#searchTextControl").focus();
            },
                1);
        };

        model.removeSearch = function () {
            model.searchContext.isShowSearchContext = !model.searchContext.isShowSearchContext;
            model.searchContext.text = "";
        };

        model.myThemeSelected = function () {
            //assign colors to scope
            $rootScope.accent = plmThemes.getThemes()[model.myThemeStyle].accent;
            $rootScope.accent2 = plmThemes.getThemes()[model.myThemeStyle].accent2;
            $rootScope.bg = plmThemes.getThemes()[model.myThemeStyle].bg;
            $rootScope.mainDark = plmThemes.getThemes()[model.myThemeStyle].mainDark;
            $rootScope.mainLight = plmThemes.getThemes()[model.myThemeStyle].mainLight;
            console.log('root', $rootScope)
            //save to db
            //doSaveTheme(model.userId, model.myThemeStyle);
        };

        //getGeneralUserInfo();
        //getUsersRole();
        //getUsersBrands();
        //getRoles();

        function logOut() {
            $rootScope.messageData = { code: "LogOut", title: "Log Out Successful" };
            $state.go('displayMessage');
            AuthenticationService.clearCredentials();
        }

        $rootScope.$watch("userPermissions", function () {
            readPermission();
        }, true);

        function readPermission() {
            angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
                //Assign permissions
                switch (userPermissionRow[0]) {
                    case 1: //LinePlan
                        model.LinePlan = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.LinePlanRead = true;
                                break;
                            case 2: //Edit
                                model.LinePlanEdit = true;
                                break;
                            case 3: //Create
                                model.LinePlanCreate = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 2: //Line Plan Template
                        model.CorporateTemplate = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.CorporateTemplateRead = true;
                                break;
                            case 2: //Edit
                                model.CorporateTemplateEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 3: //Brief
                        model.Brief = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.BriefRead = true;
                                break;
                            case 2: //Edit
                                model.BriefEdit = true;
                                break;
                            case 3: //Create
                                model.BriefCreate = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 4: //Pattern
                        model.Pattern = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.PatternRead = true;
                                break;
                            case 2: //Edit
                                model.PatternEdit = true;
                                break;
                            case 3: //Create
                                model.PatternCreate = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 5: //Prototype
                        model.Prototype = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.PrototypeRead = true;
                                break;
                            case 2: //Edit
                                model.PrototypeEdit = true;
                                model.TransferChecklist = true;
                                break;
                            case 3: //Create
                                model.PrototypeCreate = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 6: //User
                        model.ShowAdmin = true;
                        model.ShowUsers = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.UserRead = true;
                                break;
                            case 2: //Edit
                                model.UserEdit = true;
                                break;
                            case 3: //Create
                                model.UserCreate = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 7: //Role
                        model.ShowAdmin = true;
                        model.ShowRoles = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.RoleRead = true;
                                break;
                            case 2: //Edit
                                model.RoleEdit = true;
                                break;
                            case 3: //Create
                                model.RoleCreate = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 8: //Dashboard Report
                        model.Search = true;
                        break;
                    case 9: //Tools:  Library Entry
                        model.ShowTools = true;
                        model.ShowLibraries = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.LibrariesEdit = true;
                                break;
                            case 3: //Create
                                model.LibrariesCreate = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 10: //Tools:  Margin Calculator
                        model.ShowTools = true;
                        model.ShowCalc = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.CalcEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 11: //Critical Path Dev Pattern
                        model.CriticalPath = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.CriticalPathDevPatternEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 12: //Critical Path Dev Proto
                        model.CriticalPath = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.CriticalPathDevPrototypeEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 13: //Critical Path Commercialization
                        model.CriticalPath = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.CriticalPathCommercializationEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 14: //Tools:  Carryover
                        model.ShowTools = true;
                        model.ShowCarryover = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.CarryoverEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 15: //Tools:  Costing Upload
                        model.ShowTools = true;
                        model.ShowCosting = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.CostingEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 16: //Tools:  Forecasting Upload
                        model.ShowTools = true;
                        model.ShowForecasting = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.ForecastingEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 17: //Tools:  HTS Upload
                        model.ShowTools = true;
                        model.ShowHTS = true;
                        switch (userPermissionRow[1]) {
                            case 2: //Edit
                                model.HTSEdit = true;
                                break;
                            default:
                                break;
                        }
                        break;
                    case 18: //System Messages
                        model.ShowSystemMessages = true;
                        switch (userPermissionRow[1]) {
                            case 1: //Read
                                model.SystemMessageRead = true;
                                break;
                            case 2: //Edit
                                model.SystemMessageEdit = true;
                                break;
                        }
                        break;
                    case 26: //Quarterly Forecasting
                        model.ShowTools = true;
                        model.QuarterlyForecast = true;
                        break;
                    case 27: //Quarterly Forecasting
                        model.ShowAdmin = true;
                        model.QuarterlyForecastSettings = true;
                        break;
                    default:
                }
            });
        }

        //readPermission();

        model.getUserPrefs = function () {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    model.defaultBrandId = response.brandId;
                    model.defaultSeasonId = response.seasonId;
                    model.defaultDivisionKey = response.divisionKey;
                    model.useDefaultsInQuickSearch = response.useDefaultsInQuickSearch;
                }
            });
        };

       // model.getUserPrefs();


        $scope.$watch(function () { return SharedData.getRefreshTrigger(); },
            function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    model.getUserPrefs();
                }
            });
    }
})();
